import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 403) {
        console.error('Acceso denegado (403):', error);
        router.navigate(['/']);
      } else if (error.status === 400) {
        console.error('Solicitud incorrecta (400):', error);
      } else if (error.status === 404) {
        console.error('Recurso no encontrado (404):', error);
        router.navigate(['/']);
      } else if (error.status === 500) {
        console.error('Error del servidor (500):', error);
        router.navigate(['/']);
      } else {
        console.error('Error inesperado:', error);
      }
      return throwError(() => error);
    })
  );
};
